import React from 'react';

const HydrateContext = React.createContext()

export default HydrateContext